/* FATCUTPRESS Visual Registry
 * Central list of visual keys exposed to the Visual Manager.
 * New WebGL / MP4 visual adapters can register here without touching Player logic.
 */
(() => {
  'use strict';

  const registrations = [];

  function add(key, adapter) {
    if (!key || !adapter || typeof adapter !== 'object') return;
    registrations.push({ key: String(key), adapter });
  }

  function flush() {
    if (window.FATCUT_VISUAL_MANAGER) {
      registrations.splice(0).forEach(({ key, adapter }) => {
        window.FATCUT_VISUAL_MANAGER.registerVisual(key, adapter);
      });
      return;
    }

    window.FATCUT_PENDING_VISUALS = [
      ...(window.FATCUT_PENDING_VISUALS || []),
      ...registrations.splice(0)
    ];
  }

  window.FATCUT_VISUAL_REGISTRY = Object.freeze({ add, flush });
})();
